import { CLIENT_ID, IAM_URL } from '@src/configs';
import api from './api';

export const generateLoginCode = async (redirectUrl) => {
  const res = await api({
    method: 'POST',
    url: `${IAM_URL}/api/v1/auth/generate-login-code`,
    data: {
      clientId: CLIENT_ID,
      redirectUrl,
    },
    withCredentials: true,
  });
  return res;
};

export const verifyLoginCode = async (loginCode) => {
  const res = await api({
    method: 'POST',
    url: `${IAM_URL}/api/v1/auth/verify-login-code`,
    data: {
      clientId: CLIENT_ID,
      loginCode,
    },
    withCredentials: true,
  });
  return res;
};
